﻿/*global myGEC, onResizeBrowser */

var commonSiteModule = (function () {
    "use strict";

    let handlerForMessagesFromCommonSite;

    function setHandlerForMessagesFromCommonSite(handler) {
        handlerForMessagesFromCommonSite = handler;
    }

    function handleMessagesFromCommonSite(event) {
        if (handlerForMessagesFromCommonSite) {
            handlerForMessagesFromCommonSite(event);
        }
    }

    function getCommonSiteIframe() {
        return document.getElementById('commonSiteIframe');
    }

    function postMessageToCommonSite(message) {
        getCommonSiteIframe().contentWindow.postMessage(message, "*");
    }

    function setUserContextOnCommonSite() {
        postMessageToCommonSite({
            message: "setUserContext",
            userContext: myGEC.getSession()
        }, "*");
    }

    function handleStandardEventsFromCommonSite(event, minIframeHeight) {
        const DEFAULT_MIN_HEIGHT_FOR_IFRAME = 400;
        switch (event.data.message) {
            case "readyToHandleMessages":
                if (myGEC.getSession() !== null) {
                    setUserContextOnCommonSite();
                }
                break;
            case "contentHeightHasChanged":
                $(getCommonSiteIframe()).css("height", Math.max(event.data.newHeight, minIframeHeight || DEFAULT_MIN_HEIGHT_FOR_IFRAME));
                onResizeBrowser();
                break;
        }
    }

    function isMessageFromTrustedHost(host) {
        return host.replace(/\/$/, "") === serverData.commonSiteHost.replace(/\/$/, "");
    }

    window.addEventListener("message", handleMessagesFromCommonSite, false);

    // Publicly exposed methods
    return {
        handleStandardEventsFromCommonSite: handleStandardEventsFromCommonSite,
        setHandlerForMessagesFromCommonSite: setHandlerForMessagesFromCommonSite,
        postMessageToCommonSite: postMessageToCommonSite,
        isMessageFromTrustedHost: isMessageFromTrustedHost
    };

}());